import Cart from '../cart/Cart.client';
import CartToggle from '../cart/CartToggle.client';

export default function HeaderActionsNew(cart: any) {
  return (
    <>
      <CartToggle />
      <Cart productArtists={cart} />
    </>
  );
}
